import GoalType from "@/constants/GoalType";

export default {
	//
	// Goals (page)
	//
	Goals_header_text: "Goals",

	//
	// Goals and Key Results
	//

	//
	// Goals store
	//
	GoalsStore_keyResults_keyResultFetchFailed: "Key results could not be fetched: {message}",

	//
	// Components
	//

	// routes
	routes_goals_title: "Goals",

	// BinaryMeasurement
	BinaryMeasurement_currentValueLabel: "Status",
	BinaryMeasurement_invalidError: "Invalid binary choice selected.",

	// CurrencyMeasurement
	CurrencyMeasurement_currentValue_label: "Current",
	CurrencyMeasurement_currentValue_numericCurrencyError: "Current value must be numeric currency.",
	CurrencyMeasurement_currentValue_positiveNumberError: "Current value must be a positive number.",
	CurrencyMeasurement_currentValue_format: "0,0", // numeral.js
	CurrencyMeasurement_goalValue_label: "Target",
	CurrencyMeasurement_goalValue_numericCurrencyError: "Target value must be numeric currency.",
	CurrencyMeasurement_goalValue_positiveNumberError: "Target value must be a positive number.",
	CurrencyMeasurement_goalValue_format: "0,0", // numeral.js

	// DisabledMeasurement
	DisabledMeasurement_currentValue_label: "Current",
	DisabledMeasurement_goalValue_label: "Target",

	// NumericMeasurement
	NumericMeasurement_currentValue_label: "Current",
	NumericMeasurement_currentValue_realNumberError: "Current value must be a valid real number.",
	NumericMeasurement_currentValue_positiveNumberError: "Current value must be a positive number.",
	NumericMeasurement_currentValue_format: "0,0", // numeral.js
	NumericMeasurement_goalValue_label: "Target",
	NumericMeasurement_goalValue_realNumberError: "Target value must be a valid real number.",
	NumericMeasurement_goalValue_positiveNumberError: "Target value must be a positive number.",
	NumericMeasurement_goalValue_format: "0,0", // numeral.js

	// PercentageMeasurement
	PercentageMeasurement_currentValue_label: "Current",
	PercentageMeasurement_currentValue_validPercentageError: "Current value must be a valid percentage.",
	PercentageMeasurement_currentValue_greaterThanPercentError: "Current value must be greater than 0%.",
	PercentageMeasurement_currentValue_lessThanPercentError: "Current value must be less than 100%.",
	PercentageMeasurement_currentValue_format: "0", // numeral.js
	PercentageMeasurement_goalValue_label: "Target",
	PercentageMeasurement_goalValue_validPercentageError: "Target value must be a valid percentage.",
	PercentageMeasurement_goalValue_greaterThanPercentError: "Target value must be greater than 0%.",
	PercentageMeasurement_goalValue_lessThanPercentError: "Target value must be less than 100%.",
	PercentageMeasurement_goalValue_format: "0", // numeral.js

	// EmptyState
	EmptyState_loadingTitle: "Attempting to load your goals and key results. Please wait.",
	EmptyState_sortingTitle: "Sorting goals...",
	EmptyState_title: "You haven't created any goals.",
	EmptyState_description: "Goals empower your team to stay focused on what matters, with a clear view of progress toward results that keep you moving forward. Let's get started by creating your first goal.",
	EmptyState_createButton: "Create Goal",

	// GoalDatePicker
	GoalDatePicker_cancelButton: "Cancel",
	GoalDatePicker_okButton: "OK",
	GoalDatePicker_defaultDateDisplayFormat: "MMM DD, YYYY", // moment.js

	// GoalDialog
	GoalDialog_newGoal_header: "New Goal",
	GoalDialog_newGoal_allFieldsRequired: "All fields are required.",
	GoalDialog_editGoal_header: "Editing Goal",
	GoalDialog_name_hint: "Where do you want to go? Be ambitious.",
	GoalDialog_name_label: "Name your goal",
	GoalDialog_name_invalidError: "Please name your goal.",
	GoalDialog_team_hint: "Who owns this goal?",
	GoalDialog_team_label: "Select a team",
	GoalDialog_team_requiredError: "Please chose a team.",
	GoalDialog_team_invalidError: "Invalid team selected.",
	GoalDialog_startDate_label: "Start Date",
	GoalDialog_startDate_requiredError: "Start date is required.",
	GoalDialog_startDate_invalidError: "Start date is not valid.",
	GoalDialog_startDate_beforeTargetDateError: "Start date must occur prior to target date.",
	GoalDialog_startDate_isDraftGoal: "Future Goals will be saved in Drafts.",
	GoalDialog_targetDate_label: "Target Date",
	GoalDialog_targetDate_requiredError: "Target date is required.",
	GoalDialog_targetDate_invalidError: "Target date is not valid.",
	GoalDialog_targetDate_afterStartDateError: "Target date must occur after start date.",
	GoalDialog_confidenceLevel_hint: "Select your confidence level for this goal.",
	GoalDialog_confidenceLevel_label: "Confidence level",
	GoalDialog_confidenceLevel_requiredError: "Please choose a confidence level.",
	GoalDialog_confidenceLevel_invalidError: "Invalid confidence level selected.",
	GoalDialog_newKeyResultButton: "KEY RESULT",
	GoalDialog_cancelButton: "Cancel",
	GoalDialog_saveGoalButton: "Save Goal",
	GoalDialog_startDate_format: "YYYY-MM-DD",
	GoalDialog_targetDate_format: "YYYY-MM-DD",
	GoalDialog_editGoalError: "Goal does not exist, or may not be edited.",
	GoalDialog_editGoalTeamError: "Goal team does not exist, or you are not a member.",
	GoalDialog_saveSuccessMessage: "Goal saved successfully.",
	GoalDialog_saveWithKeyResultsSuccessMessage: "Goal and key results saved successfully.",
	GoalDialog_saveErrorMessage: "Unexpected error saving goal: {error}.",
	GoalDialog_archiveSuccessMessage: "Goal archived successfully.",
	GoalDialog_archiveErrorMessage: "Unexpected error while archiving goal: {error}.",
	GoalDialog_unarchiveSuccessMessage: "Goal unarchived successfully.",
	GoalDialog_unarchiveErrorMessage: "Unexpected error while unarchiving goal: {error}.",
	GoalDialog_deleteSuccessMessage: "Goal deleted successfully.",
	GoalDialog_deleteErrorMessage: "Unexpected error while deleting goal: {error}.",
	GoalDialog_fetchTeamErrorMessage: "Unexpected error fetching team: {error}.",
	GoalDialog_fetchKeyResultsErrorMessage: "Unexpected error fetching key results: {error}.",
	GoalDialog_updateInlineKeyResultSuccess: "Key result updated.",
	GoalDialog_updateInlineKeyResultError: "Unexpected error updating key result: {error}.",
	GoalDialog_unknownError: "unknown error",

	// KeyResult
	KeyResult_name_hint: "How will you get there? Be clear, actionable, and measurable.",
	KeyResult_name_label: "Key Result",
	KeyResult_owner_label: "Owner",
	KeyResult_owner_enabledHint: "Who is accountable?",
	KeyResult_owner_disabledHint: "Please assign a team to your goal first.",
	KeyResult_measurement_hint: "How will you measure progress?",
	KeyResult_measurement_label: "Measurement",
	KeyResult_removeKeyResultButton: "Remove",
	KeyResult_name_requiredError: "A key result must be named.",
	KeyResult_duplicateNameError: "A key result with this name already exists for the assigned team member.",
	KeyResult_owner_notATeamMemberError: "Selected owner is not a member of goal team.",
	KeyResult_measurement_invalidError: "Invalid measurement level selected.",

	// GoalList

	GoalList_activeTab: "Active",
	GoalList_draftTab: "Draft",
	GoalList_archivedTab: "Archived",
	GoalList_top_placeholder: "All Teams & 1:1s",
	GoalList_teams_placeholder: "My Teams",
	GoalList_1o1s_placeholder: "My 1:1s",
	GoalList_newGoalButton: "NEW GOAL",
	GoalList_goalKeyResultColumn: "Goal / Key Result",
	GoalList_dueColumn: "Due",
	GoalList_progressColumn: "Progress",
	GoalList_pacingColumn: "Pacing",
	GoalList_confidenceColumn: "Confidence",
	GoalList_updatedColumn: "Updated",
	GoalList_loadingText: "Loading...",

	// GoalRow
	GoalRow_loadingMessage: "Loading key results. Please wait.",
	GoalRow_deleteConfirmation_headerText: "Deleting a goal",
	GoalRow_deleteConfirmation_bodyText: "Delete '{title}' from your goals?",
	GoalRow_archiveConfirmation_headerText: "Archiving a goal",
	GoalRow_archiveConfirmation_bodyText: "Move '{title}' to the archive?",
	GoalRow_noKeyResultsMessage: "No key results have been defined for this goal.",

	// KeyResultRow
	KeyResultRow_type_currencyFormat: "$0,0",
	KeyResultRow_type_numericFormat: "0,0",

	// Meeting Center Goals
	MeetingCenterGoals_EmptyState_title: "This team has no active goals.",
	MeetingCenterGoals_EmptyState_createButton: "New Goal",

	// KeyResultProgressMenu
	KeyResultProgressMenu_okButton: "OK",
	KeyResultProgressMenu_cancelButton: "Cancel",

	//
	// TeamGoalListPlaceholder
	//
	TeamGoalListPlaceholder_newGoalButton: "New Goal",

	//
	// TeamGoals
	//
	[ `TeamGoals_${GoalType.ACTIVE}GoalsHeading` ]: "Active Goals",
	[ `TeamGoals_${GoalType.DRAFT}GoalsHeading` ]: "Draft Goals",
	[ `TeamGoals_${GoalType.ARCHIVED}GoalsHeading` ]: "Archived Goals",
	TeamGoals_newGoalButton: "New Goal",

	//
	// Enums
	//

	// KeyResultBinaryChoice
	KeyResultBinaryChoice_COMPLETE: "Complete",
	KeyResultBinaryChoice_INCOMPLETE: "Incomplete",

	// ConfidenceLevel enum
	ConfidenceLevel_HIGH: "HIGH",
	ConfidenceLevel_MEDIUM: "MEDIUM",
	ConfidenceLevel_LOW: "LOW",

	// KeyResultMeasurement enum
	KeyResultMeasurement_NUMERIC: "Numerical",
	KeyResultMeasurement_PERCENTAGE: "Percentage",
	KeyResultMeasurement_CURRENCY: "Currency",
	KeyResultMeasurement_BINARY: "Binary",

	// GoalType
	GoalType_ACTIVE: "active",
	GoalType_DRAFT: "draft",
	GoalType_ARCHIVE: "archive",
};



// WEBPACK FOOTER //
// ./src/lang/en/gokr.js